import React from 'react'
import cx from 'classnames'
import styles from './FileButton.sass'

interface FileButtonProps {
  onChange?: (e: FileList) => unknown
  overlay?: boolean
  children?: React.ReactNode
  accept?: string
  multiple?: boolean
  disabled?: boolean
  hover?: boolean
  stretchButton?: boolean
}

/**
 * Wraps any component and overlays a file input.
 */
export default function FileButton({
  children,
  onChange,
  overlay,
  multiple,
  hover,
  stretchButton,
  ...rest
}: FileButtonProps) {
  const change = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.files ?? new FileList())
    },
    [onChange],
  )

  return (
    <div
      className={cx(
        styles.root,
        overlay && styles.fill,
        hover && styles.hover,
        stretchButton && styles.stretchButton,
      )}
    >
      {children}
      <input
        multiple={multiple || false}
        value=""
        {...rest}
        type="file"
        onChange={change}
        className={styles.input}
      />
    </div>
  )
}
